import { call } from "../dashboard/service";
import AdministratorConstants from "./AdministratorConstants";
export default {
  namespaced: true,
  state: {
    students: [],
    studentPages: [],
    student: {},
    searchResults: [],
    applications: [],
    settings: {},
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    administratorGetters: (state) => (value) => state[value],
  },
  actions: {
    students({ commit }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", AdministratorConstants.STUDENTS(data.params.page))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "students",
            data: res.data.data.data,
          });
          commit("MUTATE", {
            state: "studentPages",
            data: res.data.data,
          });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    searchStudents({ commit }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", AdministratorConstants.SEARCH, data)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "searchResults",
            data: res.data.data,
          });
        })
        .catch(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          // Event.$emit("ApiError", error.response.data.message);
        });
    },
    getStudent({ commit }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", AdministratorConstants.STUDENT(data.reg))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "student", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.res.data.message);
        });
    },
    adminSendActivationLink: ({ dispatch, commit }, data) => {
      commit("Dashboard/SET_LOADING", false, { root: true });
      call("post", AdministratorConstants.ACTIVATION, data)
        .then((res) => {
          res.data === null
            ? Event.$emit("ApiWarning", `${res}! Please try again later`)
            : Event.$emit("ApiSuccess", `${res.data.data}!`);
          dispatch("students");
        })
        .catch((error) => {
          Event.$emit("ApiError", `${error.response.data.message}`);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    deleteStudent({ commit }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("delete", AdministratorConstants.DELETE_STUDENT(data.id))
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", res.data.message);
          Event.$emit("refetch", "Administrator/students");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.res.data.message);
        });
    },
    getApplications({ commit }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("get", AdministratorConstants.APPLICATIONS)
        .then((res) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          commit("MUTATE", { state: "applications", data: res.data.data });
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.res.data.message);
        });
    },
    syncAllApplications({ commit, dispatch }) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", AdministratorConstants.APPLICATIONS_SYNCALL)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Synced all applications");
          dispatch("getApplications");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.res.data.message);
        });
    },
    syncApplication({ commit, dispatch }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", AdministratorConstants.APPLICATIONS_SYNC, data)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Synced all application");
          dispatch("getApplications");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.res.data.message);
        });
    },
    notify({ commit }, data) {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", AdministratorConstants.USER_NOTIFICATIONS, data)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Successfully Sent Notification");
        })
        .catch((error) => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiError", error.res.data.message);
        });
    },
    getSettings: ({ commit }) => {
      call("get", AdministratorConstants.ADMIN_SETTINGS)
        .then((res) => {
          commit("MUTATE", { state: "settings", data: res.data.data });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
        });
    },
    addSettings: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", AdministratorConstants.ADMIN_SETTINGS, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Added successfully");
          dispatch("getSettings");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
    updateSettings: ({ commit, dispatch }, payload) => {
      commit("Dashboard/SET_LOADING", true, { root: true });
      call("post", AdministratorConstants.UPDATE_SETTINGS, payload)
        .then(() => {
          commit("Dashboard/SET_LOADING", false, { root: true });
          Event.$emit("ApiSuccess", "Updated successfully");
          dispatch("getSettings");
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("Dashboard/SET_LOADING", false, { root: true });
        });
    },
  },
};
